export const defaultEmpresa = () => {
  return {
    id: null,
    nombre: '',
    nit: '',
    direccion: '',
    telefono: '',
    responsable: '',
    horasarl: '',
    correo: '',
    aplica_control_accesos: 0,
    is_new_business_model: 0,
    dominio: '',
    responsable_interno: '',
    licensing_contract: '',

    // Datos para microsoft online azure auth
    use_auth_microsoft_azure: 0,
    client_id: '',
    tenant_id: '',
    secret_value: ''

  };
};

export const listadoHistorico = () => {
  return {
    listado: []
  };
};


export const listadoUsuario = () => {
  return {
    listado: [],
    data: []
  };
};

export const defaultImagen = () => {
  return {
    orientacion: 'Horizontal',
    imagen: '',
    tipo: ''
  };
};

export const listadoOrientaciones = () => {
  return {
    orientaciones: [
      'Horizontal',
      'Vertical'
    ]
  };
};

export const defaultUsuario = () => {
  return {
    cedula: '',
    name: '',
    email: '',
    telefono: '',
    multiusuario: 0,
    tipo_multiusuario: 0,
    activo: 1,
    roles: [],
    roles_usuario: [],
    rol: null,
    permisos: [],
    recibe_reportes: 0,
    interno: 0,
  };
};

export const defaultCamposPersonalizados = () => {
  return {
    nombre: '',
    activo: 1,
    editar: false,
    stbutton: 'success',
    button: 'Crear',
    titulo: 'Crear Campo Personalizado'
  };
};

export const defaultOpcionesPersonalizados = () => {
  return [
    {value: 1, text: 'Si'},
    {value: 0, text: 'No'}
  ];
};

export const listadoCamposPersonalizados = () => {
  return {
    lista: []
  };
};

export const defaultDiseno = () => {
  return {
    fondo: '#ffffff',
    letra: '#000000',
    qr: false,
    etiqueta_mini: false,
    etiqueta_vertical: 0,
    etiqueta_resolucion: 0,
    formatos_etiquetas_seleccionados: [
      {value: 'pdf', text: 'Pdf'}
    ],
    selectedFormatoEtiqueta: 'pdf'
  };
};

export const defaultMensaje = () => {
  return {
    mensajeet: '',
    medida4x6: 6,
    medida7x10: 8,
    medida18x10: 14,
    medida21x18: 14
  };
};



"verificados"
    "asignados"
    "pagos"
    "te_adj"
    "te_gen"
    "uso"
    "desuso"
    "aprobados"


export const defaultCardsTotals = () => {
  return {
    verificados: 0,
    asignados: 0,
    pagos: 0,
    te_adj: 0,
    te_gen: 0,
    uso: 0,
    desuso: 0,
    aprobados: 0,
  };
};

export const defaultSummary = () => {
  return {
    caracterizados: 0,
    asignados: 0,
    verificados: 0,
    con_FDS: 0,
    con_MSDS: 0,
    sin_Docs: 0,
    id_modelo: ''

  };
};


export const defaultAsignacionRpq = () => {
  return {
    totalRpq: 0,
    asignados: 0,
    sin_MSDS: 0,
    valorSumar: 0
  };
};

export const edicionUsuario = () => {
  return {
    id: '',
    name: '',
    email: '',
    telefono: '',
    password: '',
    multiusuario: '0',
    tipo_multiusuario: 0,
    recibe_reportes: 0,
    activo: 1
  };
};

export const defaultInventario = () => {
  return {
    tipo: '',
    mys: 0,
    base: '',
    area: '',
    empresa: ''
  };
};

/**
 * Valores por defecto del administrador de usuarios.
 *
 * @return {*}
 */
export const defaultUserFilter = () => {
  return {
    id_empresa: 0,
    paginado: true,
    page: 1,
    perPage: 10,
    sortBy: 'name',
    sort: 'asc',
    busqueda: '',
    activo: ''
  }
}

export const asignadosRpq = () => {

};

/**
 * Valores por defecto del formulario de contratistas.
 *
 * @return {*}
 */
export const defaultParamsContratista = () => {
  return {
    filtro: '',
    asignadas: false
  }
}

/**
 * Valores por defecto del buscador de empresas.
 *
 * @return {Object}
 */
export const defaultCompanyFilter = () => {
  return {
    blockade_status: '',
    nombre: '',
    paginado: true,
    page: 1,
    perPage: 15,
    sortBy: 'nombre',
    sort: 'asc',
    busqueda: ''
  }
}

export const dataInititalFdsConfigsReport = () => {
  return {
    locations: [],
    is_active: 1,
    sys_user_id: '',
    slq_inventory_id: '',
    record_user: ''
  }
}

export default {
  empresas: [],
  selectedEmpresa: defaultEmpresa(),
  selectedCamposPersonalizados: defaultCamposPersonalizados(),
  listadoHistorico: listadoHistorico(),
  selectedImagen: defaultImagen(),
  selectedImagenCurrentCompany: defaultImagen(),
  listadoOrientaciones: listadoOrientaciones(),
  selectedUsuario: defaultUsuario(),
  medidas: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  listadoCamposPersonalizados: listadoCamposPersonalizados(),
  selectedDiseno: defaultDiseno(),
  selectedMensaje: defaultMensaje(),
  selectedResumenRpq: defaultCardsTotals(),
  selectedAsignacionRpq: defaultAsignacionRpq(),
  listadoUsuario: listadoUsuario(),
  edicionUsuario: edicionUsuario(),
  opcionesPersonalizado: defaultOpcionesPersonalizados(),
  selectedInventario: defaultInventario(),
  optformatos: [
    {value: 'pdf', text: 'Pdf'},
    {value: 'word', text: 'Word'}
  ],
  formatosEtiquetaEmpresa: [
    {value: 'pdf', text: 'Pdf'},
    {value: 'word', text: 'Word'}
  ],
  optempresa: [
    {value: '', text: ''}
  ],
  optbases: [
    {value: '', text: ''}
  ],
  optareas: [
    {value: '', text: ''}
  ],
  inventario: [],
  descargaInventario: '',
  accion: 'create',
  filtro: defaultCompanyFilter(),
  roles: [],
  permisos: [],
  buscaPermiso: {
    permiso: ''
  },
  rolusuario: {},
  permisosSeleccionados: {ids: []},
  rolesSeleccionados: [],
  id_creado: 0,
  errorEmpresa: true,
  errorUsu: true,
  imagenCargada: false,
  asignadosRpq: asignadosRpq(),
  users: defaultUserFilter(),
  conexion: 0,
  contratista: 0,
  contratistas: [],
  contratistas_filtrados: {
    contratistas: []
  },
  paramsContratista: defaultParamsContratista(),
  selectedExcelUsuarios: {
    archivo: ''
  },
  importesAgendados: [],
  accionUsuario: 'Crear',
  modal_usuario: {
    mostrar: false
  },
  accionCamposPersonalizados: 'Crear',
  modal_campos_personalizados: {
    mostrar: false
  },
  licencia_activa: false,
  licencia: {
    id: null,
    id_empresa: null,
    cantidad_usuarios: 1,
    fechas: [],
    fecha_inicio: null,
    fecha_fin: null,
    usuarios_multiusuarios: 0,
    usuarios_contratistas: 0,
    modalidad_pago: null,
    precio: null,
    observaciones: null
  },
  listadoUsuarioInternos: [],
  providers: [],
  empresa: null,
  fdsConfigsReportUser: dataInititalFdsConfigsReport(),
  // variable configurable de empresa por usuario
  configVarUser: '',
  // variables configurable de empresa
  configVarCompany: [],
  summaryInfo: defaultSummary(),
  assingPermissions: false,
  validateCompany: false,
};
